export const INPUT_SEARCH_DEFAULT_DEBOUNCE_MS = 400;
